import { LangKey, MONTHS_ENG, MONTHS_RU } from 'config';
import { useEffect, useMemo, useState } from 'react';
import { localStorageManager } from 'services/localStorage';
import { getOptions } from '../../utils/utils';

export const useMonths = () => {
  const [months, setMonths] = useState<string[] | null>(null);
  const lang = localStorageManager.getLanguage();

  useEffect(() => {
    const isEn = lang === LangKey.en || lang === null;
    const arr = isEn ? [...MONTHS_ENG] : [...MONTHS_RU];

    setMonths(arr);
  }, [lang]);

  const monthOptions = useMemo(() => getOptions(months || []), [months]);

  return { months, monthOptions };
};
